<template>
  <div>
    <!-- 选择商品 -->
    <el-dialog
      title="选择商品"
      :visible.sync="isShowGoodsVisible"
      destroy-on-close
      @close="chooseShop"
      width="50%"
    >
      <input-form
        style="margin: 20px 0"
        :inputData="commodityList"
        :immediately="true"
        @toParentVal="searchContent"
      ></input-form>
      <el-table
        :data="tableShopData"
        stripe
        style="width: 90%; margin: 0 auto"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        v-loading="tableLoading"
      >
        <el-table-column width="100">
          <template slot-scope="scope">
            <img
              :src="scope.row.logo"
              class="avar"
              alt="商品图片"
              style="height: 60px; width: 60px"
            />
          </template>
        </el-table-column>
        <el-table-column prop="skuName" label="商品名称" width="300">
          <template slot-scope="scope">
            <a :href="scope.row.itemUrl" target="_blank"
              >{{ scope.row.skuName }}<br />
              ¥{{ scope.row.jdPrice }}</a
            >
          </template>
        </el-table-column>
        <el-table-column prop="skuId" label="SKU ID" width="200">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="chooseShop(scope.row)"
              style="width: 50px"
              >选择</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin: 40px 80px 0 0; text-align: right"
        background
        @size-change="handleSizeChangeThr"
        @current-change="handleCurrentChangeThr"
        :current-page="formShopList.current"
        :page-sizes="[5, 10, 30, 50, 100]"
        :page-size="formShopList.size"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
        :total="totalListThr"
      ></el-pagination>
    </el-dialog>
  </div>
</template>
<script>
import inputForm from "@/components/inputForm";
import { getTaobaoItemListSku, getSellercats } from "@/api/analysis/ware-controller.js";
export default {
  components: {
    inputForm,
  },
  props: {
    isShowGoodsVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableLoading: false,
      totalListThr: 0,
      formShopList: { current: 1, size: 5, skuStatus: 1 },
      tableShopData: [],
      commodityList: [
        {
          name: "商品类目:",
          placeholder: "请选择",
          val: "categoryId",
          cascaderArr: [],
          multiple: true,
          width: 240,
        },
        {
          name: "SKU ID:",
          val: "skuId",
          placeholder: "请输入SKU ID",
          isNumber: true,
          width: 240,
        },
        {
          name: "商品名称:",
          val: "skuName",
          placeholder: "请输入商品名称",
          width: 240,
        },
        {
          name: "商品状态:",
          val: "skuStatus",
          default: 1,
          selectArr: [
            { label: "全部", id: null },
            { label: "上架", id: 1 },
            { label: "下架", id: 2 },
          ],
          width: 136,
        },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.getShopList();
  },
  methods: {
    //获取店铺商品
    getShopList() {
      this.tableLoading = true
      getTaobaoItemListSku(this.formShopList).then((res) => {
        this.tableLoading = false
        this.tableShopData = res.data.records;
        this.totalListThr = Number(res.data.total);
      });
    },
    getSeller() {
      // 获取商品类目
      getSellercats().then((res) => {
        let data = this.transverter(res.data);
        this.getTrees(data);
        let list = data.filter((item) => item.parent_id == 0);
        let cascaderArr = list.map((item) => {
          return {
            label: item.label,
            value: item.value,
            children: item.children,
          };
        });
        this.commodityList[0].cascaderArr = cascaderArr;
      });
    },
    transverter(data) {
      // 排重
      let obj = {};
      for (let i = 0; i < data.length; i++) {
        obj[data[i]["categoryId"]] = data[i];
      }
      let arr = Object.values(obj);
      var newData = [];
      // console.log(arr);
      for (var i = 0; i < arr.length; i++) {
        newData[i] = {
          value: arr[i].categoryId,
          parent_id: arr[i].parentId,
          label: arr[i].name,
          isChecked: false,
        };
      }
      return newData;
    },
    getTrees(list, parent_id = 0) {
      let parentObj = {};
      list.forEach((o) => {
        parentObj[o.id] = o;
      });
      if (!parent_id) {
        return list
          .filter((o) => !parentObj[o.parent_id])
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      } else {
        return list
          .filter((o) => o.parent_id == parent_id)
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      }
    },
    //实物选择
    chooseShop(val) {
      this.$emit("chooseGoods", val);
    },
    // 实物查询
    searchContent(val) {
      this.formShopList.size = 5;
      this.formShopList.current = 1;
      if (val.categoryId) {
        this.formShopList.categoryId = val.categoryId.join(",");
      } else {
        this.formShopList.categoryId = "";
      }
      this.formShopList.skuId = val.skuId;
      this.formShopList.skuStatus = val.skuStatus;
      this.formShopList.skuName = val.skuName;
      this.getShopList();
    },
    //分页事件
    handleSizeChangeThr(val) {
      this.formShopList.size = val;
      this.getShopList();
    },
    handleCurrentChangeThr(val) {
      this.formShopList.current = val;
      this.getShopList();
    },
  },
};
</script>
<style lang="scss" scoped></style>
